var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 39,
    viewBox: "0 0 66 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2386_15866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29236 1.54297H35.5969C36.5684 1.54297 37.3616 2.32786 37.3864 3.33549V36.0222C37.3864 37.0217 36.5999 37.8089 35.6248 37.8089H3.29236C2.31726 37.8089 1.53076 37.0217 1.53076 36.0222V3.32974C1.53076 2.33022 2.31726 1.54297 3.29236 1.54297ZM9.88428 19.5066C9.88428 24.83 14.1505 29.1819 19.4586 29.1819C24.7388 29.1819 29.0329 24.83 29.0329 19.4783C29.0329 14.1227 24.7348 9.83123 19.4586 9.83123C14.1794 9.83123 9.88428 14.1822 9.88428 19.5066Z",
    fill: "#407DBB",
    stroke: "#237FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.112 19.4781C65.112 24.2746 61.268 28.1534 56.5377 28.1534C51.8074 28.1534 47.9634 24.2746 47.9634 19.4781C47.9634 14.6816 51.8074 10.8027 56.5377 10.8027C61.2679 10.8027 65.112 14.6816 65.112 19.4781Z",
    fill: "#407DBB",
    stroke: "#237FC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2386_15866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 38,
    fill: "white",
    transform: "translate(0.611816 0.619141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.e99d50a565e2590b47fb5071262c589a.svg";
export { ForwardRef as ReactComponent };